export default __webpack_public_path__ + "static/media/eggclosed.4c02b684.png";